import { FC } from 'react';
import { Field } from 'redux-form';
import { ReduxTextField } from '.';
import i18n from '../../../translations/i18n';
interface ReduxFormFieldProps {
    name: string;
    label?: string;
    helperText?: string | i18n.TFunction;
    multiline?: boolean;
    validate?: any[];
    select?: any;
    type?: string;
    disabled?: boolean;
    inputProps?: any;
    required?: any;
    min?: number;
    children?: any;
    normalize?: any;
    autoComplete?: string;
    InputProps?: any;
    defaultValue?: string; // Optional default value
    [key: string]: any;
}
/** wraps ReduxTextField into redux-form field component  */
const ReduxFormField: FC<ReduxFormFieldProps> = (props) => {
    const { children, defaultValue, ...fieldProps } = props;
    return (<Field fullWidth component={ReduxTextField} {...fieldProps} 
    // The defaultValue is passed to the custom component as input.value if initial value is undefined
    format={(value: any) => value === undefined ? defaultValue : value}>
      {children}
    </Field>);
};
export default ReduxFormField;
